import { message } from 'antd';
import axios, { AxiosRequestConfig, Method } from 'axios';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const getToken = (): string | null => {
  return localStorage.getItem('accessToken');
};
// Base configuration for axios
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Replace with your API base URL
  timeout: 10000, // Request timeout
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

interface ApiRequestProps {
  url: string;
  method?: Method;
  payload?: any;
  showMessage?: boolean;
  Authentication?: boolean;
  naviToLogin?:boolean;
  cstmSuccMsg?:string;
  trackHistory?:boolean;
}
let navi = true;
let msgShow = true;

const useApiRequest = () => {
  const navigate = useNavigate();

  axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response && error.response.status === 401) {
        // Clear the token from localStorage
        localStorage.removeItem('accessToken');
        // Redirect to the login page
        if(navi){
          navigate('/account');
        }

        // Show error message
        message.destroy();
        // message.error('Session expired. Please login again.');
        if(msgShow){
          message.warning('Please login')
        }
      }
      return Promise.reject(error);
    }
  );

  const apiRequest = async ({
    url,
    method = 'GET',
    payload = {},
    showMessage = false,
    Authentication = false,
    naviToLogin = true,
    cstmSuccMsg,
    trackHistory=false,
  }: ApiRequestProps): Promise<any> => {
    navi = naviToLogin;
    msgShow = showMessage;
    if (Authentication &&!getToken()) {
      // Redirect to login page if token is not found

      // console.log(window.URL)
      if(naviToLogin){
        navigate('/account');
      }
      if(showMessage){
        message.error("User not authenticated. Please login.");
      }
    }
    

    // const token = getToken();
    // if (!token) {
    //   // Redirect to login page if token is not found
    //   navigate('/account');
    //   message.error("User not authenticated. Please login.");
    // }

    try {
      const config: AxiosRequestConfig = {
        method,
        url,
        ...(method === 'POST' || method === 'PUT' ? { data: payload } : { params: payload }),
      };

      const response = await axiosInstance(config);
      if (showMessage) {
        message.success(cstmSuccMsg?cstmSuccMsg:"Request Success!");
      }
      
      return response;
    } catch (error: any) {
      if (showMessage) {
        message.error(`Error: ${error.response ? error.response.data.message : error.message}`);
      }
      console.error('API request error:', error);
      throw error;
    }
  };

  return { apiRequest };
};

export default useApiRequest;


export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}



// Room types 

export const serviceOptions = [
  { value: "", label: "Select one..." },
  // { value: "Bulk ordering", label: "Bulk ordering" },
  { value: "Virtual Staging", label: "Virtual Staging" },
  { value: "Commercial Virtual Staging", label: "Commercial Virtual Staging" },
  // { value: "Matterport Virtual Staging", label: "Matterport Virtual Staging" },
  { value: "Virtual Renovation", label: "Virtual Renovation" },
  { value: "Image Enhancement", label: "Image Enhancement" },
  { value: "Object Removal", label: "Object Removal" },
  { value: "Occupied To Vacant", label: "Occupied To Vacant" },
  { value: "Day To Dusk", label: "Day To Dusk" },
  { value: "Floor Plan", label: "Floor Plan" },
  // { value: "360 Virtual Tour", label: "360° Virtual Tours" },
  // { value: "3D rendering", label: "3D Render" },
  // { value: "Single Property Website", label: "Single Property Website" },
  { value: "Other", label: "Other" }
];

export const roomOptions = [
    "Living/Dining/Kitchen",
    "Living/Dining",
    "Family Room",
    "Dining/Kitchen",
    "Dining",
    "Kitchen",
    "Bedroom 1",
    "Bedroom 2",
    "Bedroom 3",
    "Bedroom 4",
    "Primary/Master Bedroom",
    "Study/Office",
    "Closet",
    "Outdoor Living",
    "Sunroom",
    "Outdoor Living/Dining",
    "Bathroom/Ensuite",
    "Rumpus Room",
    "Game Room",
    "Media Room/Theatre Room",
    "Single Room Studio",
    "Nursery Room",
    "Kids Room/Play Room",
    "Yoga/Meditation Room",
    "Gym/Workout Room",
    "Lounge",
    "Other",
    "Living",
    "Dining",
    "Kitchen",
    "Lounge/Dining/Kitchen",
    "Lounge/Kitchen",
    "Lounge/Dining",
    "Dining/Kitchen",
    "Lounge",
    "Family Room",
    "Primary/Master Bedroom",
    "Bedroom",
    "Study",
    "Home Office",
    "Sun Room",
    "Outdoor Living",
    "Bathroom/Ensuite",
    "Rumpus Room",
    "Games Area",
    "Media Room",
    "Kids Room",
    "Nursery Room",
    "Single Room Studio",
    "Others (Please specify in additional information below)",
  ];

  export  const designCardsData = [
    { 
        name: "Modern",
        thumbnail: `${process.env.REACT_APP_ADMIN_STORAGE_URL}/main_photo_4_Web_1751402039.webp`,
        images: [
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/Bedroom_glam_Web_1751402039.webp`,
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/bedroom2_k_g_Web_1751402039.webp`,
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/Dining_k_g_1_Web_1751402039.webp`,
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/Modern_Living_ren_Web_1751402039.webp`,
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/main_photo_4_Web_1751402039.webp`
        ]
    },
    { 
        name: "Contemporary",
        thumbnail: `${process.env.REACT_APP_ADMIN_STORAGE_URL}/pexels_curtis_adams_1694007_15242103_lr_g_Web_1751401401.webp`,
        images: [
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/Bedroom_g_Web_1751401401.webp`,
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/bedroom2_k_gig_Web_1751401401.webp`,
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/Dining_k_g_Web_1751401401.webp`,
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/Living_k_g_Web_1751401401.webp`,
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/pexels_curtis_adams_1694007_15242103_lr_g_Web_1751401401.webp`
        ]
    },
    { 
        name: "Traditional",
        thumbnail: `${process.env.REACT_APP_ADMIN_STORAGE_URL}/Living_Dining1_Web_1751402278.webp`,
        images: [
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/Bedroom1_Web_1751402278.webp`,
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/bedroom21_Web_1751402278.webp`,
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/Dining1_Web_1751402278.webp`,
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/Living1_Web_1751402278.webp`,
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/Living_Dining1_Web_1751402278.webp`
        ]
    },
    { 
        name: "Coastal",
        thumbnail: `${process.env.REACT_APP_ADMIN_STORAGE_URL}/LR1_ren_Web_1750000666.webp`,
        images: [
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/Dining_staged_Web_1750000666.webp`,
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/Coastal_LR_DR1_Web_1750000666.webp`,
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/bedroom2rn_Web_1750000666.webp`,
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/Bedroom_1_Web_1750000665.webp`,
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/LR1_ren_Web_1750000666.webp`
        ]
    },
    { 
        name: "Scandinavian",
        thumbnail: `${process.env.REACT_APP_ADMIN_STORAGE_URL}/living_dining_Web_1751402149.webp`,
        images: [
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/bedroom_01_Web_1751402149.webp`,
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/bedroom_02_Web_1751402149.webp`,
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/dining_Web_1751402149.webp`,
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/living_Web_1751402149.webp`,
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/living_dining_Web_1751402149.webp`,
        ]
    },
    { 
        name: "Farmhouse", 
        thumbnail: `${process.env.REACT_APP_ADMIN_STORAGE_URL}/LIVING_1Bg_Web_1751401555.webp`, 
        images: [
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/bedroom_01_Web_1751401555.webp`, 
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/bedroom_02_Web_1751401555.webp`, 
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/dining_Web_1751401555.webp`, 
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/living_Web_1751401555.webp`,
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/LIVING_1Bg_Web_1751401555.webp`,
        ] 
    },
    { 
        name: "Industrial", 
        thumbnail: `${process.env.REACT_APP_ADMIN_STORAGE_URL}/living_dinig_Web_1751401773.webp`, 
        images: [
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/bedroom_01_indus_Web_1751401773.webp`, 
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/bedroom_02_Web_1751401773.webp`, 
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/dining_Web_1751401773.webp`, 
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/living_Web_1751401773.webp`, 
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/living_dinig_Web_1751401773.webp`
        ] 
    },
    { 
        name: "Glam", 
        thumbnail: `${process.env.REACT_APP_ADMIN_STORAGE_URL}/livng_dining_Web_1751401655.webp`, 
        images: [
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/glam_bedroom_01_Web_1751401655.webp`, 
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/glam_bedroom_02_Web_1751401655.webp`,
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/dining_Web_1751401655.webp`, 
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/living_Web_1751401655.webp`,
            `${process.env.REACT_APP_ADMIN_STORAGE_URL}/livng_dining_Web_1751401655.webp`
        ] 
    },
];

export const threeDesignCard = [
  { 
      name: "Modern",
      thumbnail: `${process.env.REACT_APP_ADMIN_STORAGE_URL}/main_photo_4_Web_1751402039.webp`,
      images: [
        `${process.env.REACT_APP_ADMIN_STORAGE_URL}/Bedroom_glam_Web_1751402039.webp`,
        `${process.env.REACT_APP_ADMIN_STORAGE_URL}/bedroom2_k_g_Web_1751402039.webp`,
        `${process.env.REACT_APP_ADMIN_STORAGE_URL}/Dining_k_g_1_Web_1751402039.webp`,
        `${process.env.REACT_APP_ADMIN_STORAGE_URL}/Modern_Living_ren_Web_1751402039.webp`,
        `${process.env.REACT_APP_ADMIN_STORAGE_URL}/main_photo_4_Web_1751402039.webp`
      ]
  },
  { 
      name: "Contemporary",
      thumbnail: `${process.env.REACT_APP_ADMIN_STORAGE_URL}/pexels_curtis_adams_1694007_15242103_lr_g_Web_1751401401.webp`,
      images: [
        `${process.env.REACT_APP_ADMIN_STORAGE_URL}/Bedroom_g_Web_1751401401.webp`,
        `${process.env.REACT_APP_ADMIN_STORAGE_URL}/bedroom2_k_gig_Web_1751401401.webp`,
        `${process.env.REACT_APP_ADMIN_STORAGE_URL}/Dining_k_g_Web_1751401401.webp`,
        `${process.env.REACT_APP_ADMIN_STORAGE_URL}/Living_k_g_Web_1751401401.webp`,
        `${process.env.REACT_APP_ADMIN_STORAGE_URL}/pexels_curtis_adams_1694007_15242103_lr_g_Web_1751401401.webp`
      ]
  },
  { 
      name: "Industrial", 
      thumbnail: `${process.env.REACT_APP_ADMIN_STORAGE_URL}/living_dinig_Web_1751401773.webp`, 
      images: [
        `${process.env.REACT_APP_ADMIN_STORAGE_URL}/bedroom_01_indus_Web_1751401773.webp`, 
        `${process.env.REACT_APP_ADMIN_STORAGE_URL}/bedroom_02_Web_1751401773.webp`, 
        `${process.env.REACT_APP_ADMIN_STORAGE_URL}/dining_Web_1751401773.webp`, 
        `${process.env.REACT_APP_ADMIN_STORAGE_URL}/living_Web_1751401773.webp`, 
        `${process.env.REACT_APP_ADMIN_STORAGE_URL}/living_dinig_Web_1751401773.webp`
      ]
  },
];


export function formatDate(dateString: string, format: string = "YYYY-MM-DD HH:mm:ss"): string {
  const date = new Date(dateString);

  const pad = (n: number): string => n.toString().padStart(2, "0");

  const replacements: { [key: string]: string | number } = {
    YYYY: date.getFullYear(),
    MM: pad(date.getMonth() + 1),
    DD: pad(date.getDate()),
    HH: pad(date.getHours()),
    mm: pad(date.getMinutes()),
    ss: pad(date.getSeconds()),
  };

  return format.replace(/YYYY|MM|DD|HH|mm|ss/g, (token) => replacements[token].toString());
}

